import { useEffect, useState } from "react";
import { CourseCard } from "../components/CourseCard";
import { FaDownload } from "react-icons/fa";
import { Link } from "react-router-dom";
import { CardCourseSkeleton } from "../../cards/skeletons/CardCourseSkeleton";

// --- PERBAIKAN: Pastikan setiap objek memiliki 'id' yang unik ---
// const allCourses = [
//   {
//     id: 1,
//     title: "What is Cryptocurrency?",
//     duration: "20 Mins",
//     concepts: ["Overview of digital currencies", "Key terms and concepts"],
//   },
//   {
//     id: 2,
//     title: "Basics of Blockchain",
//     duration: "20 Mins",
//     concepts: ["Understanding distributed ledgers", "How transactions work"],
//   },
//   {
//     id: 3,
//     title: "Link Between Cryptocurrency...",
//     duration: "20 Mins",
//     concepts: ["Exploring different use cases", "Future of blockchain"],
//   },
//   {
//     id: 4,
//     title: "What is Cryptocurrency? (Copy)", // Judul dibedakan untuk kejelasan
//     duration: "20 Mins",
//     concepts: ["Overview of digital currencies", "Key terms and concepts"],
//   },
//   {
//     id: 5,
//     title: "Basics of Blockchain (Copy)",
//     duration: "20 Mins",
//     concepts: ["Understanding distributed ledgers", "How transactions work"],
//   },
//   {
//     id: 6,
//     title: "Link Between Cryptocurrency... (Copy)",
//     duration: "20 Mins",
//     concepts: ["Exploring different use cases", "Future of blockchain"],
//   },
//   {
//     id: 7,
//     title: "What is Cryptocurrency? (Copy 2)",
//     duration: "20 Mins",
//     concepts: ["Overview of digital currencies", "Key terms and concepts"],
//   },
//   {
//     id: 8,
//     title: "Basics of Blockchain (Copy 2)",
//     duration: "20 Mins",
//     concepts: ["Understanding distributed ledgers", "How transactions work"],
//   },
//   {
//     id: 9,
//     title: "Link Between Cryptocurrency... (Copy 2)",
//     duration: "20 Mins",
//     concepts: ["Exploring different use cases", "Future of blockchain"],
//   },
// ];

const ProgressLearning = ({
  finishedCourses,
  ongoingCourses,
  progressPercent,
  modulesLeft,
  allCourses,
  loading,
}) => {
  const [isCompletedAllCourse, setIsCompletedAllCourse] = useState(false);
  const INITIAL_VISIBLE_COUNT = 4;
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_COUNT);

  const handleShowMore = () => {
    setVisibleCount(allCourses.length);
  };

  const remainingCount = allCourses.length - visibleCount;
  const showMoreButtonIsVisible = remainingCount > 0;

  useEffect(() => {
    if (progressPercent === 100) {
      setIsCompletedAllCourse(true);
    }
  }, [progressPercent]);

  return (
    <div className="rounded-xl">
      {/* Top Banner */}
      <div
        className="rounded-2xl flex justify-between items-center mb-4"
        style={{
          background: isCompletedAllCourse
            ? "linear-gradient(92deg, #D0E7E6  1.42%, #A1F8F4  116.35%)"
            : "linear-gradient(92deg, #D9DFF6 1.42%, #98ACF9 116.35%)",
        }}
      >
        <div className="p-6 w-full md:w-1/2">
          <p
            className={`${
              isCompletedAllCourse
                ? "text-sm md:text-xl font-semibold text-black"
                : "text-base text-[#585F72] "
            }`}
          >
            {isCompletedAllCourse
              ? "Hooray! You Have Been Pass the Test 🎉"
              : "Get Certificate and finish..."}
          </p>

          {isCompletedAllCourse ? (
            <Link to={"/certificate"}>
              <div className="my-4 py-1 px-3 border-2 border-[#007A78] flex bg-white rounded-md items-center flex flex-row gap-2 justify-center w-fit text-[#007A78] ">
                Download Certificate <FaDownload className="w-3 h-3" />
              </div>
            </Link>
          ) : (
            <h1 className="text-4xl font-bold text-[#2D224E] my-1 text-left">
              {allCourses.length} Course
            </h1>
          )}
          <div className="grid grid-cols-3 bg-white w-full md:w-[400px] rounded-md ring-1 ring-[#485E92] my-5">
            {/* Div pertama (tidak ada perubahan) */}
            <div className="py-2 text-center">
              <p className="font-medium text-gray-800 text-base my-1">Finish</p>
              <p className="text-gray-600 text-base my-1">{finishedCourses}</p>
            </div>

            {/* Div kedua (dengan garis pembatas custom) */}
            <div className="relative py-2 text-center">
              {/* Garis Pembatas Dibuat di Sini */}
              <div className="absolute inset-y-4 left-0 w-0.5 bg-gray-200"></div>

              <p className="font-medium text-gray-800 text-base my-1">
                On Going
              </p>
              <p className="text-gray-600 text-base my-1">{ongoingCourses}</p>
            </div>

            {/* Div ketiga (dengan garis pembatas custom) */}
            <div className="relative py-2 text-center">
              {/* Garis Pembatas Dibuat di Sini */}
              <div className="absolute inset-y-4 left-0 w-0.5 bg-gray-200"></div>

              <p className="font-medium text-gray-800 text-base my-1">
                Progress
              </p>
              <p className="text-gray-600 text-base my-1">
                {Math.round(progressPercent)}%
              </p>
            </div>
          </div>
        </div>
        <div className="hidden md:flex w-1/2 items-right justify-end">
          {/* Placeholder untuk ilustrasi */}
          {isCompletedAllCourse ? (
            <div className="mr-5">
              <img src={"/images/img_course_finished.svg"} />
            </div>
          ) : (
            <div className="mr-5">
              <img src={"/images/img_course.svg"} />
            </div>
          )}
        </div>
      </div>

      {/* Daftar Kursus */}
      <div className="">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          {!isCompletedAllCourse ? "On Going Course" : "Last Course"}
        </h2>

        <div className="p-4 md:p-6 bg-white rounded-[10px] ">
          {loading ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
              {[...Array(4)].map((_, idx) => (
                <CardCourseSkeleton key={idx} />
              ))}
            </div>
          ) : !!allCourses.length ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
              {allCourses.slice(0, visibleCount).map((course) => (
                // Sekarang 'key' dijamin unik, sehingga render akan berjalan dengan benar
                <CourseCard key={course.id} lesson={course} />
              ))}
            </div>
          ) : (
            <div className="min-h-[50vh] flex items-center w-full justify-center bg-white rounded-md">
              <div className="flex flex-col">
                <img
                  src="/images/no_data_available.svg"
                  alt="Community Image"
                />
                <p className="text-base">No activity yet.. start learn!</p>
              </div>
            </div>
          )}

          {/* Tombol Show More */}
          {showMoreButtonIsVisible && (
            <div className="mt-6">
              <button
                onClick={handleShowMore}
                className="px-6 py-2 ring-1 ring-[#2D224E] rounded-lg font-semibold text-gray-700 hover:bg-gray-100 !bg-white transition-colors"
              >
                Show {remainingCount} more
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressLearning;
